import _defineProperty from "/home/myaccountconso/web/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

export var setLoanVisibility = function setLoanVisibility(productList, filters) {
  var activeFilters = [];
  var counter = 0;

  for (var prop in filters) {
    if (filters[prop]) {
      activeFilters.push(prop);

      if (prop != 'online') {
        counter++;
      }
    }
  }

  var index1 = activeFilters.indexOf('fixedInterest');
  var index2 = activeFilters.indexOf('variableInterest');

  if (index1 > -1 && index2 > -1) {
    activeFilters.splice(index1, 1);
    index2 = activeFilters.indexOf('variableInterest');
    activeFilters.splice(index2, 1);
  }

  var visibleProducts = 0;
  var filteredProductList = productList.map(function (p) {
    var status = true;
    activeFilters.forEach(function (f) {
      switch (f) {
        case 'online':
          if (!p.hasOwnProperty('apply')) {
            status = false;
          }

          break;

        case 'withIncome':
          if (p.withIncome) {
            status = false;
          }

          break;

        case 'lifeInsurance':
          if (!p.lifeInsurance) {
            status = false;
          }

          break;

        case 'fixedInterest':
          if (p.rateType == 'variabila') {
            status = false;
          }

          break;

        case 'variableInterest':
          if (p.rateType != 'variabila') {
            status = false;
          }

          break;
      }
    });

    if (!status) {
      return _objectSpread(_objectSpread({}, p), {}, {
        visible: false
      });
    }

    visibleProducts++;
    return _objectSpread(_objectSpread({}, p), {}, {
      visible: true
    });
  });
  var response = {
    updatedOffers: filteredProductList,
    visibleProducts: visibleProducts,
    counterFilters: counter
  };
  return response;
};
export var countFilters = function countFilters(filters) {
  var counter = 0;

  for (var prop in filters) {
    if (filters[prop]) {
      if (prop != 'online') {
        counter++;
      }
    }
  }

  return counter;
};
export var countOffersForFilter = function countOffersForFilter(productList, filter, online) {
  switch (filter) {
    case 'online':
      return productList.reduce(function (sum, p) {
        return sum + (p.hasOwnProperty('apply') && p.apply ? 1 : 0);
      }, 0);
      break;

    case 'withIncome':
      return online ? productList.reduce(function (sum, p) {
        return sum + (p.hasOwnProperty('withIncome') && p.withIncome && p.hasOwnProperty('apply') && p.apply ? 1 : 0);
      }, 0) : productList.reduce(function (sum, p) {
        return sum + (p.hasOwnProperty('withIncome') && p.withIncome ? 1 : 0);
      }, 0);
      break;

    case 'lifeInsurance':
      return online ? productList.reduce(function (sum, p) {
        return sum + (p.hasOwnProperty('lifeInsurance') && p.lifeInsurance && p.hasOwnProperty('apply') && p.apply ? 1 : 0);
      }, 0) : productList.reduce(function (sum, p) {
        return sum + (p.hasOwnProperty('lifeInsurance') && p.lifeInsurance ? 1 : 0);
      }, 0);
      break;

    case 'fixedInterest':
      return online ? productList.reduce(function (sum, p) {
        return sum + (p.rateType != 'variabila' && p.hasOwnProperty('apply') && p.apply ? 1 : 0);
      }, 0) : productList.reduce(function (sum, p) {
        return sum + (p.rateType != 'variabila' ? 1 : 0);
      }, 0);
      break;

    case 'variableInterest':
      return online ? productList.reduce(function (sum, p) {
        return sum + (p.rateType == 'variabila' && p.hasOwnProperty('apply') && p.apply ? 1 : 0);
      }, 0) : productList.reduce(function (sum, p) {
        return sum + (p.rateType == 'variabila' ? 1 : 0);
      }, 0);
      break;
  }
};
export var countOffersByFilters = function countOffersByFilters(productList, filters) {
  var counter = {};

  for (var prop in filters) {
    counter[prop] = countOffersForFilter(productList, prop, filters.online);
  }

  return counter;
};
export var countOnlineVisibleOffers = function countOnlineVisibleOffers(productList, filters) {
  var newFilters = _objectSpread(_objectSpread({}, filters), {}, {
    online: true
  });

  var visibleOffers = countAllVisibleOffers(productList, newFilters);
  return visibleOffers;
};
export var countBankVisibleOffers = function countBankVisibleOffers(productList, filters) {
  var newFilters = _objectSpread(_objectSpread({}, filters), {}, {
    online: false
  });

  var visibleOffers = countAllVisibleOffers(productList, newFilters);
  return visibleOffers;
};
export var countAllVisibleOffers = function countAllVisibleOffers(productList, filters) {
  var activeFilters = [];

  for (var prop in filters) {
    if (filters[prop]) {
      activeFilters.push(prop);
    }
  }

  var index1 = activeFilters.indexOf('fixedInterest');
  var index2 = activeFilters.indexOf('variableInterest');

  if (index1 > -1 && index2 > -1) {
    activeFilters.splice(index1, 1);
    index2 = activeFilters.indexOf('variableInterest');
    activeFilters.splice(index2, 1);
  }

  var visibleProducts = 0;
  var filteredProductList = productList.map(function (p) {
    var status = true;
    activeFilters.forEach(function (f) {
      switch (f) {
        case 'online':
          if (!p.hasOwnProperty('apply')) {
            status = false;
          }

          break;

        case 'withIncome':
          if (p.withIncome) {
            status = false;
          }

          break;

        case 'lifeInsurance':
          if (!p.lifeInsurance) {
            status = false;
          }

          break;

        case 'fixedInterest':
          if (p.rateType == 'variabila') {
            status = false;
          }

          break;

        case 'variableInterest':
          if (p.rateType != 'variabila') {
            status = false;
          }

          break;
      }
    });

    if (status) {
      visibleProducts++;
    }
  });
  return visibleProducts;
};
export var getProductDescription = function getProductDescription(product, option) {
  var options = {
    'personalLoans': {
      'personal loan': 'Nevoi personale',
      'home equity loan': 'Nevoi cu ipoteca'
    },
    'autoLoans': {
      'new car loan': 'Credit pentru auto nou',
      'used car loan': 'Credit pentru auto second-hand',
      'first car loan': 'Credit Prima Mașină'
    },
    'mortgageLoans': {
      'mortgage buy': 'Cumpărare locuință',
      'mortgage build': 'Construcție locuință',
      'mortgage repair': 'Modernizare locuință'
    },
    'refinanceLoans': {
      'mortgage refinance': 'Refinanțare Credit imobiliar',
      'refinance personal loan': 'Refinanțare Credit nevoi personale',
      'refinance home equity loan': 'Refinanțare Credit cu ipotecă'
    },
    'deposits': {
      'all': 'Depozit la termen',
      'branch': 'Depozit la termen - în sucursală',
      'online': 'Depozit la termen - online'
    },
    'creditCard': {
      'all': 'Oricare',
      'rewards': 'Puncte bonus',
      'cashback': 'Cashback',
      'freeInterest': 'Rate fără dobândă',
      'premium': 'Premium',
      'balanceTransfer': 'Refinanțare'
    }
  };
  return options[product][option];
};
export var checkMortgageDownPayment = function checkMortgageDownPayment(amount, currency, house, houseCurrency, eur) {
  var minDownPaymentRate = currency == 'RON' ? 15 : 25;

  var _getDownPayment = getDownPayment(amount, currency, house, houseCurrency, eur),
      housePrice = _getDownPayment.housePrice,
      downPayment = _getDownPayment.downPayment,
      downPaymentRate = _getDownPayment.downPaymentRate;

  if (downPayment <= 0) {
    return {
      status: false,
      msg: 'Valoarea creditului trebuie să fie mai mare decât valoarea casei'
    };
  }

  if (downPaymentRate < minDownPaymentRate) {
    var maxAmount = new Intl.NumberFormat('fr', {
      maximumFractionDigits: 1
    }).format(housePrice * (100 - minDownPaymentRate) / 100);
    return {
      status: false,
      msg: 'Avansul minim este de ' + minDownPaymentRate + '%. Valoarea creditului nu poate depăși ' + maxAmount + ' ' + currency
    };
  }

  return {
    status: true,
    msg: ''
  };
};
export var checkRefinanceCollateral = function checkRefinanceCollateral(amount, currency, house, houseCurrency, eur) {
  var minDownPaymentRate = currency == 'RON' ? 15 : 25;
  var minCollateralRate = 100 - minDownPaymentRate;

  var _getDownPayment2 = getDownPayment(amount, currency, house, houseCurrency, eur),
      housePrice = _getDownPayment2.housePrice,
      downPayment = _getDownPayment2.downPayment,
      downPaymentRate = _getDownPayment2.downPaymentRate;

  if (downPayment <= 0) {
    return {
      status: false,
      msg: 'Valoarea creditului trebuie să fie mai mare decât valoarea garanției imobiliare'
    };
  }

  if (downPaymentRate < minDownPaymentRate) {
    var maxAmount = new Intl.NumberFormat('fr', {
      maximumFractionDigits: 1
    }).format(housePrice * (100 - minDownPaymentRate) / 100);
    return {
      status: false,
      msg: 'Banca finanțează maxim ' + minCollateralRate + '% din valoarea garanției imobiliare. Suma maximă ce poate fi refinanțată este de ' + maxAmount + ' ' + currency
    };
  }

  return {
    status: true,
    msg: ''
  };
};
export var checkFirstHomeHousePrice = function checkFirstHomeHousePrice(house, houseCurrency, eur) {
  var housePriceEur = houseCurrency == 'RON' ? house / eur : house;

  if (housePriceEur > 140000) {
    var msg = 'Valoarea locuintei nu poate depasi 140.000 euro';

    if (houseCurrency == 'RON') {
      var maxHousePrice = 140000 * eur;
      msg += ' (echivalent ' + new Intl.NumberFormat('fr', {
        maximumFractionDigits: 0
      }).format(maxHousePrice) + ' RON)';
    }

    return {
      status: false,
      msg: msg
    };
  }

  return {
    status: true,
    msg: ''
  };
};
export var checkFirstHomeDownPayment = function checkFirstHomeDownPayment(amount, currency, house, houseCurrency, eur) {
  var housePriceEur = houseCurrency == 'RON' ? house / eur : house;

  var _getDownPayment3 = getDownPayment(amount, currency, house, houseCurrency, eur),
      housePrice = _getDownPayment3.housePrice,
      downPayment = _getDownPayment3.downPayment,
      downPaymentRate = _getDownPayment3.downPaymentRate;

  var minDownPaymentRate = housePriceEur <= 70000 ? 5 : 15;

  if (downPayment <= 0) {
    return {
      status: false,
      msg: 'Valoarea creditului trebuie să fie mai mare decât valoarea casei'
    };
  }

  if (downPaymentRate < minDownPaymentRate) {
    var maxAmount = new Intl.NumberFormat('fr', {
      maximumFractionDigits: 1
    }).format(housePrice * (100 - minDownPaymentRate) / 100);
    return {
      status: false,
      msg: 'Avansul minim este de ' + minDownPaymentRate + '%. Valoarea creditului nu poate depăși ' + maxAmount + ' ' + currency
    };
  }

  return {
    status: true,
    msg: ''
  };
};
export var getDownPayment = function getDownPayment(amount, currency, house, houseCurrency, eur) {
  var housePrice;

  if (currency == houseCurrency) {
    housePrice = house;
  } else {
    housePrice = currency == 'RON' ? house * eur : house / eur;
  }

  var downPayment = (housePrice - amount).toFixed(0);
  var downPaymentRate = (downPayment / housePrice * 100).toFixed(1);
  return {
    downPayment: downPayment,
    downPaymentRate: downPaymentRate,
    housePrice: housePrice
  };
};
export var getDepositInterestType = function getDepositInterestType(val) {
  switch (val) {
    case 'fixed':
      return 'fixă';
      break;

    case 'variable':
      return 'variabilă';
      break;
  }
};
export var getDepositInterestPayment = function getDepositInterestPayment(val) {
  switch (val) {
    case 'term':
      return 'la scadență';
      break;

    case 'month':
      return 'lunar';
      break;

    case 'quarter':
      return 'trimestrial';
      break;

    case 'semester':
      return 'semestrial';
      break;

    case 'advance':
      return 'la constituire';
      break;
  }
};
export var getSavingAccountInterestCalculation = function getSavingAccountInterestCalculation(val) {
  switch (val) {
    case 'balance':
      return 'la sold';
      break;

    case 'bracket':
      return 'pe trașe';
      break;
  }
};
export var getLoanInterestType = function getLoanInterestType(val) {
  switch (val) {
    case 'fixa':
      return 'fixă';
      break;

    case 'variabila':
      return 'variabilă';
      break;

    case 'fixa 1 luna':
      return 'fixă 1 lună';
      break;

    case 'fixa 3 luni':
      return 'fixă 3 luni';
      break;

    case 'fixa 6 luni':
      return 'fixă 6 luni';
      break;

    case 'fixa 1 an':
      return 'fixă 1 an';
      break;

    case 'fixa 2 ani':
      return 'fixă 2 ani';
      break;

    case 'fixa 3 ani':
      return 'fixă 3 ani';
      break;

    case 'fixa 5 ani':
      return 'fixă 5 ani';
      break;

    case 'fixa 7 ani':
      return 'fixă 7 ani';
      break;

    case 'fixa 10 ani':
      return 'fixă 10 ani';
      break;

    default:
      return '';
  }
};